import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const WorkerPlanPaymentFailed = () => {
    return (
        <>
            Payment Failed
        </>
    );
};

export default WorkerPlanPaymentFailed;